import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    interval: { type: Number, default: 30 },
    url: String
  }

  connect() {
    this.startPolling()
    this.boundVisibilityHandler = this.handleVisibilityChange.bind(this)
    document.addEventListener("visibilitychange", this.boundVisibilityHandler)
  }

  disconnect() {
    this.stopPolling()
    document.removeEventListener("visibilitychange", this.boundVisibilityHandler)
  }

  startPolling() {
    this.stopPolling()
    this.pollTimer = setInterval(() => this.refresh(), this.intervalValue * 1000)
  }

  stopPolling() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer)
      this.pollTimer = null
    }
  }

  handleVisibilityChange() {
    if (document.hidden) {
      this.stopPolling()
    } else {
      this.refresh()
      this.startPolling()
    }
  }

  refresh() {
    if (this.urlValue) {
      Turbo.visit(this.urlValue, { action: "replace" })
      return
    }

    const frame = this.element.closest("turbo-frame")
    if (frame) {
      frame.reload()
    }
  }
}
